








import VueOptions from '@utils/VueOptions'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'ListingsTopVenuesListChart'

  vue:
    props: ['data']

    components: {
      BoxChart,
    }

export default VueOptions.vue settings
